import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Divider, DividerModule } from 'primeng/divider';

@Component({
  selector: 'ui-divider',
  standalone: true,
  imports: [DividerModule],
  templateUrl: './divider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerComponent {
  public readonly label = input<string>('');
  public readonly align = input<Divider['align']>(undefined);
  public readonly layout = input<Divider['layout']>('horizontal');
  public readonly type = input<Divider['type']>('solid');
}
